import React from 'react'
import { useTranslation } from 'react-i18next'
import { useRouter } from 'next/router'
import * as S from './SectionAppBioAtlas.styles'
import ImageNext from '@/components/ImageNext'

const SectionAppBioAtlas = () => {
  const { t } = useTranslation()
  const router = useRouter()

  return (
    <S.Section>
      <S.Container className="mw-unsigned">
        <S.LeftCol>
          <S.Title>{t('landingV2.sectionAppBioAtlas.title')}</S.Title>
          <S.DownloadRow>
            <S.DownloadText>
              {t('landingV2.sectionAppBioAtlas.downloadText')}
            </S.DownloadText>
            <S.StoreLogos>
              <ImageNext
                src={`${process.env.CDN_URL}/public/landingpagev2/images/apple-store-logo.png`}
                alt="Apple Store"
                width={40}
                height={40}
              />
              <ImageNext
                src={`${process.env.CDN_URL}/public/landingpagev2/images/play-store-logo.png`}
                alt="Play Store"
                width={40}
                height={40}
              />
            </S.StoreLogos>
          </S.DownloadRow>
          <S.AppButton onClick={() => router.push('/Resources/App')}>
            {t('landingV2.sectionAppBioAtlas.button')}
          </S.AppButton>
        </S.LeftCol>
        <S.RightCol>
          <S.TabletImg>
            <ImageNext
              src={`${process.env.CDN_URL}/public/landingpagev2/images/tablet.png`}
              alt="App BioAtlas no tablet"
              width={443}
              height={309}
            />
          </S.TabletImg>
        </S.RightCol>
      </S.Container>
      <S.PhoneImg>
        <ImageNext
          src={`${process.env.CDN_URL}/public/landingpagev2/images/phone.png`}
          alt="App BioAtlas no celular"
          width={132}
          height={151}
        />
      </S.PhoneImg>
    </S.Section>
  )
}

export default SectionAppBioAtlas
